/**
 * @license
 * Copyright 2023 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

class HumanReview {
  state: string;
  state_message: string = "";

  constructor(state: string, state_message: string = "") {
    this.state = state;
    this.state_message = state_message;
  }
}

export class Revision {
  id: string = "0";
  parent?: string[];
  parent_ids: string[] = [];
  create_time: string = new Date().toISOString();
  agent: string;
  processor?: string;
  human_review?: HumanReview;
  lastRevisionId?: string;

  constructor(
    reviewedDocumentJson: any,
    humanRevisionState: string,
    humanRevisionStateMessage: string,
    userId: string
  ) {
    this.parent_ids = [];
    this.lastRevisionId = "0";
    reviewedDocumentJson.revisions = reviewedDocumentJson.revisions || [];
    const lastRevision = reviewedDocumentJson.revisions
      .slice()
      .sort((a: Revision, b: Revision) => {
        return (a < b);
      })
      .pop();
    this.lastRevisionId = lastRevision?.id || this.lastRevisionId;
    lastRevision?.parent_ids?.push(this.lastRevisionId);
    this.parent_ids = lastRevision?.parent_ids || [this.lastRevisionId];
    this.id = String((parseInt(this.lastRevisionId || "") || 0) + 1);
    if (humanRevisionState !== "rejected") {
      humanRevisionState = "succeeded";
    };
    this.create_time = new Date().toISOString();
    this.human_review = new HumanReview(humanRevisionState,humanRevisionStateMessage);
    this.agent = userId;
  }
}
